exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sticky-banner[data-v-61f04a92] {\n  width: 100%;\n  position: fixed;\n  z-index: 100;\n  top: 0;\n  left: 0;\n  right: 0;\n  transition: all 0.3s;\n  transform: translateY(-120px);\n}\n.sticky-banner__fixed[data-v-61f04a92] {\n  transform: translateY(0);\n}", ""]);

// exports
